const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'https://user-management-api.dcbusc2012.workers.dev'
};

export default config; 